import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useLegacyIframeResizeMessage from "../../hooks/useLegacyIframeResizeMessage";
import schema from "../../validation/bookeeSchema";
import LargeContainer from "../../Components/Container/LargeContainer";
import SmallContainer from "../../Components/Container/SmallContainer";
import LoadingScreen from "../../Components/LoadingScreen/LoadingScreen";
import Form from "../../Components/Forms/Form";
import CustomButton from "../../Components/Button/CustomButton";
import { searchExistingBooking } from "../../bookingapi/booking.operations";
import SubHeading from "../../Components/Text/SubHeading";
import { Checkbox, FormControl, FormErrorMessage } from "@chakra-ui/react";
import PopUp from "../../Components/PopUp/PopUp";
import useLocalisation from "../../hooks/useLocalisation";

const LandingPage = () => {
  useLegacyIframeResizeMessage();
  const navigate = useNavigate();
  const { landingPageData } = useLocalisation();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  const [formData, setFormData] = useState({
    customerFirstName: "",
    customerLastName: "",
    phoneNumber: "",
    emailAddress: "",
    reference: "",
    customerConsent: false,
    notes: ""
  });

  // prevent user from using browser back button
  useEffect(() => {
    if (window.self !== window.top) {
      // in iframe do nothing
      return;
    }

    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  function handleFormChange(event) {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  }

  // TODO: fully await or promise not both.
  /**
   * validate
   * get booking window
   * redirect to add-booking passing form data
   */
  const onContinuePress = async () => {
    setIsLoading(true);
    schema
      .validate(formData, { abortEarly: false })
      .then(async () => {
        setErrors({});
        try {
          try {
            const existingBooking = await searchExistingBooking(
              formData.phoneNumber,
              formData.emailAddress
            );
            return existingBooking.length === 0 ?
              navigate("/add-booking", { state: { ...formData } }) :
              navigate(`/update-booking?token=${existingBooking}`);
          } catch (error) {
            throw error;
          }

        } catch (error) {
          setIsLoading(false);
          setIsPopUpOpen(true);
        }
      })
      .catch((validationErrors) => {
        const errors = validationErrors.inner.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.path]: curr.message,
          }),
          {}
        );
        setErrors(errors);
        setIsLoading(false);
      });
  };

  const privacyPolicy = (
    <a href={landingPageData.privacyPolicyLink} target="_blank" rel="noreferrer">
      {landingPageData.privacyPolicyLinkText}
    </a>
  );

  return (
    <LargeContainer minH={"100vh"}>
      <SmallContainer px={{ base: "2%" }} alignItems={"center"} maxW="600px" margin="0 auto">
        <SmallContainer  alignItems={"center"}>
          {isLoading && (
            <LoadingScreen
              loadingText={"Hold tight"}
              loadingSubText={"It will just take a few moments"}
            />
          )}
          {isPopUpOpen && (
            <PopUp
              popUpHeading={"There's been an issue"}
              popUpMessage={
                "Please review your details, if you have already registered, please check your details match your original booking to retrieve it."
              }
              isOpen={isPopUpOpen}
              onClose={() => setIsPopUpOpen(false)}
            />
          )}
          {!isLoading && (
            // THE ACTUAL FORM
            <SmallContainer backgroundColor={"#FFFFFF"} alignItems={"center"}>
              <Form
                formData={formData}
                localisation={{...landingPageData}}
                handleFormChange={handleFormChange}
                errors={errors}
              ></Form>

              <SmallContainer width={"92.92%"} marginTop="20px">
                <SubHeading
                  fontFamily="Proxima Nova"
                  fontSize="14px"
                  textTransform="none"
                  color="#000000"
                  letterSpacing="0px"
                  fontWeight="600"
                  subHeadingLabel={
                    <>
                      {landingPageData.consentText} {privacyPolicy}
                    </>
                  }
                ></SubHeading>

                <FormControl isInvalid={!!errors.customerConsent}>
                  <Checkbox
                    name="customerConsent"
                    color="#636363"
                    fontFamily="Proxima Nova"
                    marginTop="5px"
                    size="md"
                    isChecked={formData.customerConsent}
                    onChange={handleFormChange}
                  >
                    Yes
                  </Checkbox>
                  <FormErrorMessage fontSize="12" color="red">
                    {errors.customerConsent}
                  </FormErrorMessage>
                </FormControl>
              </SmallContainer>

              <CustomButton
                marginTop={"32px"}
                marginBottom={"32px"}
                onClick={onContinuePress}
                buttonLabel={"Continue"}
              ></CustomButton>
            </SmallContainer>
          )}
        </SmallContainer>
      </SmallContainer>
    </LargeContainer>
  );
};

export default LandingPage;
